import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DxListModule } from 'devextreme-angular';
import { RestApiService } from '../../shared/services/rest-api.service';
import { Permission } from '../../shared/models/permission';

import { ToolbarService } from '../../shared/services/toolbar.service';
import { Subject, takeUntil } from 'rxjs';

import { AngularFireMessaging } from '@angular/fire/compat/messaging';

@Component({
    selector: 'app-permissions',
    imports: [
        CommonModule,
        DxListModule
    ],
    templateUrl: './permissions.component.html',
    styleUrl: './permissions.component.scss'
})
export class PermissionsComponent implements OnInit {
  permissions: Permission[] = [];

  tenantId: number | undefined;
  workerNumber: string | undefined;

  private unsubscribe: Subject<void> = new Subject<void>();


  public tokenList: string[] = [];
  public notificationUserToken: string;


  constructor(
    private restApiService: RestApiService,
    private router: Router,
    private toolbar: ToolbarService,
    private afMessaging: AngularFireMessaging) {

    this.tenantId = Number(localStorage.getItem("tenantId"));
    this.workerNumber = localStorage.getItem("user")?.substring(3);
    this.notificationUserToken = "";
  }

  ngOnInit(): void {
    this.loadData();

    this.toolbar.BackVisibleChanged(false);
    this.toolbar.PlusVisibleChanged(true);
    this.toolbar.plusClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.NewPermission());

    this.toolbar.TitleChanged("Permessi");

    this.toolbar.CancelVisibleChanged(false);
    this.toolbar.ForwardVisibleChanged(false);
    //-----------//

    this.requestPermission();  // --> genero / recupero il token specifico dell' utente collegato in questo istante

    //-----------//
  }

  loadData(): void {
    let currentWorker: Worker | any;

    this.restApiService.getCurrentWorker().subscribe(worker => {
      currentWorker = worker;

      if (currentWorker.canApproveJustification != null && currentWorker.canApproveJustification) {
        // nal caso sia un utente che può solo approvare le modifiche 
        this.restApiService.getPermissionsByTenant(this.tenantId!).subscribe(data => {
          //this.permissions = data.filter(x => x.causal=="");  // se si vogliono solo i permessi in attesa di approvazioni 
          this.permissions = data;
          
        });
      }
      else {
        // nel caso sia un utente base 
        this.restApiService.getPermissions(this.tenantId!, this.workerNumber!).subscribe(data => {
          this.permissions = data;
        });
      }

    });

    
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  
  NewPermission() {
    this.router.navigate(['/permission']);
  }

  onCardClick = (data: Permission): void => {
    //console.log('Scheda cliccata:', data);

    this.router.navigate(['/permission', { permissionID: data.id }]);

  }

  requestPermission() {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {

        // AngularFireMessaging compat espone requestToken come Observable
        this.afMessaging.requestToken
          .subscribe({
            next: (token) => {
              if (token) {


                this.notificationUserToken = localStorage.getItem("notificationToken") ?? "";
                if (this.notificationUserToken == "") {
                  // NON ho un token per questa persona quindi gli associo il token recuperato ora da firebase
                  this.notificationUserToken = token
                  this.restApiService.aggiornaWorkerNotificationToken(this.notificationUserToken).subscribe();
                }
                else if (this.notificationUserToken != token) {
                  this.notificationUserToken = token;
                  // se arrivo qui è perchè
                  // avevo già un token ma è cambiato ( disattiva / attiva notifiche o altro e lo reimposto al nuovo token)
                  this.restApiService.aggiornaWorkerNotificationToken(this.notificationUserToken).subscribe();
                }

                // per fare delle prove di invio 
                //this.sendTestNotification();  // --> con questo invio la notifica

              }
            },
            error: (err) => {
              console.warn('Impossibile ottenere token FCM', err);
            }
          });
      }
    });
  }

}
